import { SortOptions } from '~src/spacesPlatform/models/sort/CommonSortOptions';
import { OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';
import { createNonDisplayOptionDefinition } from '~src/spacesPlatform/models/sort/SortOptionsHelper';

import { OrderKeys } from '../../../../spacesPlatform/models/OrderKeys';

export const groupSortOptions: OptionsDictionary = {
  'name': SortOptions.name,
  'domainName': createNonDisplayOptionDefinition('domainName', OrderKeys.domainName),
  'minSiteRole': createNonDisplayOptionDefinition('minSiteRole', OrderKeys.minimumSiteRole),
  'userCount': createNonDisplayOptionDefinition('userCount', OrderKeys.userCount),
  'grantLicenseMode': createNonDisplayOptionDefinition('grantLicenseMode', OrderKeys.grantLicenseMode),
};
